export const classes = (...items: string[]) =>
  items?.filter((x) => !!x).join(" ");
